module.exports = __webpack_public_path__ + "static/media/intro.52d4d6e7.mp3";